'use client'

import { LayoutContext, useLayoutState } from '@homeSearch/layout/context'
import { HomeSearchContext, useHomeSearchState } from '@homeSearch/modules/context'
import AgentSearchInputContent from './content'
import { useEffect, useMemo } from 'react'
import useAgentListContext from '../../context'
import useGetSuburbs from '@hooks/useGetSuburbs'
import getAgentRoute from '@plugin/searchRoute/modules/agent'
import { size } from 'lodash-es'

export default function AgentSearchInput({
  slug
}) {

  const layoutState = useLayoutState()
  const searchState = useHomeSearchState({
    oneSuburb: true,
    recentSuburb: false,
  })
  const { setSuburbs: agentListSetSuburbs } = useAgentListContext()
  const { setSuburbs, toggleSurrounding } = searchState

  const params = useMemo(() => {
    const agentRoute = getAgentRoute()
    const { regionId, districtId, suburbId } = agentRoute.fromSlug(slug).toQuery()
    return { regionId, districtId, suburbId }
  }, [slug])
  const { data } = useGetSuburbs(params)

  useEffect(() => {
    if (!size(data)) return
    setSuburbs(data)
    agentListSetSuburbs(data)
  }, [data, setSuburbs, agentListSetSuburbs])

  useEffect(() => {
    const agentRoute = getAgentRoute()
    agentRoute.fromSlug(slug)
    toggleSurrounding(agentRoute.surround)
  }, [slug, toggleSurrounding])

  return (
    <HomeSearchContext.Provider value={searchState}>
      <LayoutContext.Provider value={layoutState}>
        <AgentSearchInputContent></AgentSearchInputContent>
      </LayoutContext.Provider>
    </HomeSearchContext.Provider>
  )
}